module.exports = __webpack_public_path__ + "static/img/app-logo.861450ae.png";